import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function BusinessDigitalTwin({ getData }) {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    getData(
      "Digital Twin",
      "디지털 트윈은 산업의 디지털 전환을 주도할 핵심기술로 컴퓨터에 현실 속 사물의 쌍둥이(가상공간)를 만들어,",
      "현실에서 발생할 수 있는 상황을 ICT 기술을 접목하여 운영/유지관리/예측을 가능하게 합니다."
    );
    window.addEventListener("scroll", updateScroll);
  }, [getData]);

  // 스크롤 pc
  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      {pc ? (
        <div>
          <div className="inner">
            <h2 className="basic-title">DIGITAL TWIN 보유 기술</h2>
            <div className="basic-subtitle">
              <p>다양한 기술을 바탕으로 운영/유지 관리/예측에 대해</p>
              <p>대응할 수 있는 서비스를 제공합니다.</p>
            </div>
            <div>
              <ul className="technology-list">
                <li className="technology-item">
                  <span className="technology-img digital-img1"></span>
                  <h2 className="technology-name">3D 모델링 구축/갱신</h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img2"></span>
                  <h2 className="technology-name">데이터 분석/가시화/운용</h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img3"></span>
                  <h2 className="technology-name">디지털 트윈 솔루션 보유</h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img4"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">3D 모델링/데이터</span>
                    <span className="basic-block">융합 시스템 제공</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img5"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">
                      국제표준을 준수한 대용량
                    </span>
                    <span className="basic-block">처리 기술 보유(3Dtiles)</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img6"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">
                      국내 최고 품질 전국 DEM/
                    </span>
                    <span className="basic-block">
                      정사영상 데이터 서비스 제공
                    </span>
                  </h2>
                </li>
              </ul>
            </div>
          </div>

          <div
            className={
              scrollPosition > 1299
                ? "basic-banner digital-banner on"
                : "basic-banner digital-banner"
            }
          >
            <h2 className="basic-banner-title">
              <p className="txt">디지털 트윈을 선도하는</p>
              <p className="txt">기업 서비스</p>
            </h2>
          </div>

          <div className="inner">
            <ul className="business-list">
              <li className="business-item">
                <h2 className="business-title">디지털트윈 솔루션 연구개발</h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      전국 단위 고품질 서비스를 위해 서비스 가능한 타일 단위
                      전국 지형(2.5m), 정사영상(25cm) 데이터를 구축/제공하고,
                      대용량 데이터 처리가 가능한 3차원 데이터 국제표준인
                      3Dtiles 생성기술을 확보하였습니다. 접근성이 높은 Web 기반
                      솔루션과 고품질, XR지원이 가능한 Unity 기반 솔루션을
                      개발하여 디지털트윈 멀티플랫폼 제공이 가능합니다.
                    </h3>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">
                      3차원 공간 정보기반 건축물 자산관리 플랫폼 개발(중소
                      벤처기업부)
                    </li>
                    <li className="basic-cont-item">
                      3차원 공간 정보 플랫폼(DiTAP) 기반 건설관리 패키지
                      개발(중소 벤처기업부)
                    </li>
                    <li className="basic-cont-item">
                      Unity 기반의 디지털트윈 GIS 적용 기술 및 솔루션
                      개발(과학기술정보통신부)
                    </li>
                    <li className="basic-cont-item">
                      XR 기반 건설 설계 혁신 시스템(정보통신산업진흥원)
                    </li>
                  </ul>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img digital-img1"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img digital-img2"></span>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img digital-img3"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img digital-img4"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li className="business-item">
                <h2 className="business-title">디지털트윈 기술 적용 서비스</h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      서비스 유형에 따라 디지털 트윈 솔루션을 제공하고 수요처
                      요구 사항을 반영하여 서비스를 제공합니다.
                    </h3>
                    <h3 className="txt">
                      관련 서비스는 국제표준 준수와 대용량 데이터 지원이
                      가능하여 전 세계 어디든 서비스 제공이 가능합니다.
                    </h3>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">
                      서울특별시 68만동 국내최초 3Dtiles 적용
                      서비스(서울기술연구원 공동연구개발)
                    </li>
                    <li className="basic-cont-item">
                      건설 BIM 대용량 데이터 처리/서비스(건설사)
                    </li>
                  </ul>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img digital-img5"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img digital-img6"></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      ) : (
        // 모바일
        <div>
          <div className="inner">
            <h2 className="basic-title">
              <span className="txt">DIGITAL TWIN</span>
              <span className="txt">보유 기술</span>
            </h2>
            <div className="basic-subtitle">
              <p>다양한 기술을 바탕으로 운영/유지 관리/예측에</p>
              <p>대해 대응할 수 있는 서비스를 제공합니다.</p>
            </div>
            <div>
              <ul className="technology-list">
                <li className="technology-item">
                  <span className="technology-img digital-img1"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">3D 모델링</span>
                    <span className="basic-block">구축/갱신</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img2"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">데이터 분석</span>
                    <span className="basic-block">/가시화/운용</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img3"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">디지털 트윈</span>
                    <span className="basic-block">솔루션 보유</span>{" "}
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img4"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">3D 모델링/데이터</span>
                    <span className="basic-block">연계 융합 시스템 제공</span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img5"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">국제표준을 준수한</span>
                    <span className="basic-block">
                      대용량 처리 기술 보유(3Dtiles)
                    </span>
                  </h2>
                </li>
                <li className="technology-item">
                  <span className="technology-img digital-img6"></span>
                  <h2 className="technology-name">
                    <span className="basic-block">국내 최고 품질 전국</span>
                    <span className="basic-block">
                      DEM/ 정사영상 데이터 서비스 제공
                    </span>
                  </h2>
                </li>
              </ul>
            </div>
          </div>

          <div className="basic-banner digital-banner">
            <h2 className="basic-banner-title">
              <p className="txt">디지털 트윈을 선도하는</p>
              <p className="txt">기업 서비스</p>
            </h2>
          </div>

          <div className="inner">
            <ul className="business-list">
              <li className="business-item">
                <h2 className="business-title">디지털트윈 솔루션 연구개발</h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      전국 단위 고품질 서비스를 위해 서비스 가능한 타일 단위
                      전국 지형(2.5m), 정사영상(25cm) 데이터를 구축/제공하고,
                      대용량 데이터 처리가 가능한 3차원 데이터 국제표준인
                      3Dtiles 생성기술을 확보하였습니다. 접근성이 높은 Web 기반
                      솔루션과 고품질, XR지원이 가능한 Unity 기반 솔루션을
                      개발하여 디지털트윈 멀티플랫폼 제공이 가능합니다.
                    </h3>
                  </div>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img digital-img1"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img digital-img2"></span>
                      </li>
                    </ul>
                    <div>
                      <ul className="business-img-list">
                        <li className="business-img-item">
                          <span className="business-img digital-img3"></span>
                        </li>
                        <li className="business-img-item">
                          <span className="business-img digital-img4"></span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">
                      3차원 공간 정보기반 건축물 자산관리 플랫폼 개발(중소
                      벤처기업부)
                    </li>
                    <li className="basic-cont-item">
                      3차원 공간 정보 플랫폼(DiTAP) 기반 건설관리 패키지
                      개발(중소 벤처기업부)
                    </li>
                    <li className="basic-cont-item">
                      Unity 기반의 디지털트윈 GIS 적용 기술 및 솔루션
                      개발(과학기술정보통신부)
                    </li>
                    <li className="basic-cont-item">
                      XR 기반 건설 설계 혁신 시스템(정보통신산업진흥원)
                    </li>
                  </ul>
                </div>
              </li>
              <li className="business-item">
                <h2 className="business-title">디지털트윈 기술 적용 서비스</h2>
                <div className="business-cont">
                  <div className="business-txt">
                    <h3 className="txt">
                      서비스 유형에 따라 디지털 트윈 솔루션을 제공하고 수요처
                      요구 사항을 반영하여 서비스를 제공합니다. 관련 서비스는
                      국제표준 준수와 대용량 데이터 지원이 가능하여 전 세계
                      어디든 서비스 제공이 가능합니다.
                    </h3>
                  </div>
                  <div>
                    <ul className="business-img-list">
                      <li className="business-img-item">
                        <span className="business-img digital-img5"></span>
                      </li>
                      <li className="business-img-item">
                        <span className="business-img digital-img6"></span>
                      </li>
                    </ul>
                  </div>
                  <ul className="basic-cont-list">
                    <li className="basic-cont-item">
                      서울특별시 68만동 국내최초 3Dtiles 적용 서비스
                      (서울기술연구원 공동연구개발)
                    </li>
                    <li className="basic-cont-item">
                      건설 BIM 대용량 데이터 처리/서비스(건설사)
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

export default BusinessDigitalTwin;
